module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/facebook-8a1e8343ef64c0d5ff9df5f28b5b29fb.svg&quot;;"